import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionTaxiwayIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.364 16.68l-5.237-3.321-1.054 3.992 1.147 1.477-.285 1.081-2.31-1.374-2.67.059.286-1.08 1.693-.728 1.054-3.992-6.16.312.377-1.429L9.85 9.534l1.054-3.992c.08-.302.25-.53.51-.685a1.07 1.07 0 01.853-.11c.308.08.535.252.679.514.144.262.177.544.097.846L11.988 10.1l4.753 5.153-.377 1.429z'
            />
            <Path
                fill='currentColor'
                d='M19.75 8.894V24h-1.5V8.894A9.752 9.752 0 0124 0v1.677a8.248 8.248 0 00-4.25 7.217zm-18.25 0V24H0V8.894A9.752 9.752 0 015.75 0v1.677A8.248 8.248 0 001.5 8.894z'
            />
        </>
    ),
})

TaskInspectionTaxiwayIcon.displayName = 'TaskInspectionTaxiwayIcon'
